module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABGdBTUEAALGPC/xhBQAAALJJREFUOBHtlcsJg0AURWMQImQh1hCLSAFiJSkrlQQLsAhTg7gImE3wnAiuM467+OCMH+Ze3jzhmhzmKrhUUMJpfvXz+mZnBw30CYtmNzjDCAOEVM7mDF5wT1nsTLMWHvCBkDqyuYYrVD54TDtbY4bs24BaPS4aOjOPGdoZkqXU6pFpuGnthvHj3Gf4LzM0z4ygmC+uVo/RG8PRPDOC1piqUavHc/OA1dAytQ1aszHqFzABmAAh3ATaHVYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/check-box-empty.png
// module id = 492
// module chunks = 5